import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { Produktionsstatus, Maschinenplanung } from '@/modules/ewerp/models/ProduktionsstatusModels';

export type Getters = {
  produktionsstatus(state: State): Array<Produktionsstatus>;
  maschinenPlanungHeute(state: State): Array<Maschinenplanung>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  produktionsstatus(state: State) {
    return state.produktionsstatus;
  },

  maschinenPlanungHeute(state: State) {
    return state.maschinenPlanungHeute;
  },
};
